import cn from 'classnames'
import { get } from 'lodash'
import React, { useState } from 'react'
import styled from 'styled-components'

import Popover from '../popover'
import Icon from '../tntd-icon'
import images from './images'
import { getLanguageStore, getThemeStore, setLanguageStore, setThemeStore } from './storage'

const languages = [
  { value: 'cn', name: '中文' },
  { value: 'en', name: ' EN ' },
]
const languagesMap = languages.reduce((acc, cur) => {
  acc[cur.value] = cur
  return acc
}, {})

const LanguageSwitch = styled.div`
  margin-bottom: 10px;

  & > div {
    padding: 10px 13px 10px 17px;
    border-radius: 20px 0 0 20px;
    border-right: none;
    display: inline-block;
    color: #fff;
    width: 49%;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0 !important;
    color: #666;
    border: 1px solid #e5e5e5;
    vertical-align: middle;
    display: inline-block;
    letter-spacing: -4px;
    cursor: pointer;
    &:first-child {
      padding: 10px 13px 10px 17px;
      border-radius: 20px 0 0 20px;
      border-right: none;
    }
    &:last-child {
      padding: 10px 17px 10px 13px;
      border-radius: 0 20px 20px 0;
      border-left: none;
    }
    &.active {
      background-color: #4b93e5;
      border-color: #4b93e5;
      color: #fff;
    }
  }
`

const Theme = styled.li`
  margin-left: 20px;
  font-size: 20px;
  .tnt-themeS1 & {
    color: rgba(255, 255, 255, 0.85);
  }
  .isInIframe & {
    display: none;
  }
  .tnt-icon {
    font-size: 30px;
    vertical-align: middle;
    opacity: 0.75;
    color: #2b5696;
    .tnt-themeS1 & {
      /* color: #fff; */
    }
  }
`

const ThemeSwitch = styled.div`
  margin-bottom: 20px;
  & > div {
    position: relative;
    display: inline-block;
    cursor: pointer;
    img {
      width: 48px;
    }
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 10px;
    }
    & > i,
    & > .tnt-icon,
    & > .anticon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #1890ff;
    }
  }
`

const ThemeContentWrapper = styled.div`
  z-index: 1;
  background-color: #fff;
  border-radius: 4px;
  min-width: 203px;
  padding: 8px 4px 8px 8px;
  .line {
    background: #f0f0f0;
    height: 1px;
    margin: 20px 0;
    width: calc(100% + 44px);
    transform: translateX(-22px);
  }
`

const themes = [
  { value: 'themeS1', img: images.themeSymbol1 },
  { value: 'themeS2', img: images.themeSymbol2 },
]

const ThemeContent = (props) => {
  const { config, onLanguageChange, onThemeChange } = props
  const { language: languageVisible = true, theme: themeVisible = true } = config || {}
  const getTheme = () => {
    let theme = getThemeStore() || props.theme || 'themeS2'

    return themes.some(({ value }) => value === theme) ? theme : 'themeS2'
  }
  const [theme, setTheme] = useState(getTheme())
  const changeTheme = (theme) => {
    setTheme(theme)
    setThemeStore(theme)
    onThemeChange(theme)
  }
  const getLanguage = () => {
    let lang = getLanguageStore() || props.language

    if (!languagesMap[lang]) {
      lang = get(languages, '0.value')
    }

    return lang
  }
  const [language = 'cn', setLanguage] = useState(getLanguage())
  const changeLanguage = (language) => {
    setLanguage(language)
    setLanguageStore(language)
    onLanguageChange(language)
  }

  return (
    <ThemeContentWrapper>
      {themeVisible && (
        <ThemeSwitch>
          {themes.map(({ value, img }) => (
            <div key={value} onClick={changeTheme.bind(this, value)}>
              <img src={img} />
              {theme === value && <Icon type="check1" />}
            </div>
          ))}
        </ThemeSwitch>
      )}
      {themeVisible && languageVisible && <div className="line"></div>}
      {languageVisible && (
        <LanguageSwitch>
          {languages.map(({ value, name }) => (
            <div
              className={cn({ active: value === language })}
              key={value}
              onClick={changeLanguage.bind(this, value)}
            >
              {name}
            </div>
          ))}
        </LanguageSwitch>
      )}
    </ThemeContentWrapper>
  )
}

export default (props) => {
  const { config } = props

  if (config?.language === false && config?.theme === false) {
    return null
  }

  return (
    <Theme>
      <Popover
        placement="bottomRight"
        title={null}
        content={<ThemeContent {...props} />}
        trigger="click"
      >
        <Icon type="daxiaoxie" />
      </Popover>
    </Theme>
  )
}
